<template>
  <div class="ewimx-wrapper">
    <PromoLine v-bind="promoLineArgs" />

    <HeaderNavigation v-bind="headerNavigationArgs" />

    <div id="mainNavigation" class="custom">
      <div id="hero_teaser">
        <div class="inside">
          <div class="mod_article edge p-b-7 block">
            <div class="block_inner">
              <div class="container-edge">
                <div class="row">
                  <div class="col">
                    <StageHero v-bind="stageHeroArgs" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <main class="ewimx-main">
      <div class="mod_article bg_black block">
        <div class="block_inner">
          <div class="container">
            <div class="row">
              <div class="col">
                <Calculator v-bind="calculatorArgs" />
                <Information v-bind="informationArgs" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mod_article col-12 block">
        <div class="block_inner">
          <div class="container">
            <div class="row">
              <div class="col">
                <CardSlider v-bind="cardSliderArgs" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mod_article col-12 block">
        <div class="block_inner">
          <div class="container">
            <div class="row">
              <div class="col">
                <IconText v-bind="iconTextArgs" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mod_article col-12 block">
        <div class="block_inner">
          <div class="container">
            <div class="row">
              <div class="col">
                <TextBlock v-bind="textBlockArgs" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mod_article col-12 block bg-lightgrey">
        <div class="block_inner">
          <div class="container">
            <div class="row">
              <div class="col">
                <TextBlock v-bind="textBlockArgs" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mod_article col-12 block bg-lightblue">
        <div class="block_inner">
          <div class="container">
            <div class="row">
              <div class="col">
                <TextBlock v-bind="textBlockArgs" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mod_article col-12 block">
        <div class="block_inner">
          <div class="container">
            <div class="row">
              <div class="col">
                <AppBanner v-bind="appBannerArgs" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mod_article col-12 block">
        <div class="block_inner">
          <div class="container">
            <div class="row">
              <div class="col">
                <Accordion v-bind="accordionArgs" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mod_article col-12 block">
        <div class="block_inner">
          <div class="container">
            <div class="row">
              <div class="col">
                <MediaBlock v-bind="mediaBlockArgs" />
                <MediaBlock v-bind="mediaBlockVideoArgs" />
                <MediaBlock v-bind="mediaBlockVideoNativeArgs" />
                <MediaBlockWithWrapText v-bind="mediaBlockWithWrapTextArgs" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mod_article col-12 block">
        <div class="block_inner">
          <div class="container">
            <div class="row">
              <div class="col">
                <FaqThemeCardList v-bind="faqThemeCardListArgs" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mod_nodes">
        <div class="node_wrapper container">
          <FooterContact v-bind="footerContactArgs" />
        </div>
      </div>
    </main>

    <div class="bg-dark color-white">
      <FooterNavigation v-bind="footerNavigationArgs" />
    </div>

    <fabButton v-bind="fabButtonArgs">
      <template #content>
        <Calculator v-bind="calculatorArgs" />
      </template>
    </fabButton>
  </div>
</template>

<script>
import 'ewi-ui/styles/globals.scss';
import 'ewi-ui/components/3-organisms/IconText/IconText.scss';
import 'ewi-ui/components/2-molecules/IconTextItem/IconTextItem.scss';
import 'ewi-ui/components/3-organisms/NewsDetailPage/NewsDetailPage.scss';
import 'ewi-ui/components/3-organisms/FaqArticle/FaqArticle.scss';
import 'ewi-ui/components/3-organisms/NewsCardList/NewsCardList.scss';
import 'ewi-ui/components/2-molecules/NewsCardTeaser/NewsCardTeaser.scss';
import { reactive } from 'vue';
import PromoLine from 'ewi-ui/components/2-molecules/PromoLine/PromoLine.vue';
import { Default as PromoLineArgs } from 'ewi-ui/components/2-molecules/PromoLine/PromoLine.stories.ts';

import HeaderNavigation from 'ewi-ui/components/3-organisms/HeaderNavigation/HeaderNavigation.vue';

import StageHero from 'ewi-ui/components/3-organisms/StageHero/StageHero.vue';
import { Default as StageHeroArgs } from 'ewi-ui/components/3-organisms/StageHero/StageHero.stories.ts';

import Calculator from 'ewi-ui/components/3-organisms/Calculator/Calculator.vue';
import { HalfView as CalculatorArgs } from 'ewi-ui/components/3-organisms/Calculator/Calculator.stories.ts';

import IconText from 'ewi-ui/components/3-organisms/IconText/IconText.vue';
import { WithHeadlineAndRoundIcons as IconTextArgs } from 'ewi-ui/components/3-organisms/IconText/IconText.stories.ts';

import Information from 'ewi-ui/components/2-molecules/Information/Information.vue';
import { Lightgrey as InformationArgs } from 'ewi-ui/components/2-molecules/Information/Information.stories.ts';

import CardSlider from 'ewi-ui/components/3-organisms/CardSlider/CardSlider.vue';
import { Default as CardSliderArgs } from 'ewi-ui/components/3-organisms/CardSlider/CardSlider.stories.ts';

import MediaBlock from 'ewi-ui/components/2-molecules/MediaBlock';
import {
  Default as MediaBlockArgs,
  WithVideoYoutube as WithVideoYoutubeArgs,
  WithVideoNative as WithVideoNativeArgs,
} from 'ewi-ui/components/2-molecules/MediaBlock/MediaBlock.stories.ts';

import MediaBlockWithWrapText from 'ewi-ui/components/2-molecules/MediaBlockWithWrapText';
import { Default as MediaBlockWithWrapTextArgs } from 'ewi-ui/components/2-molecules/MediaBlockWithWrapText/MediaBlockWithWrapText.stories.ts';

import AppBanner from '../../2-molecules/AppBanner/AppBanner.vue';
import { Lightblue as AppBannerArgs } from '../../2-molecules/AppBanner/AppBanner.stories.js';

import TextBlock from '../../2-molecules/TextBlock/TextBlock.vue';
import { HomePage as TextBlockArgs } from '../../2-molecules/TextBlock/TextBlock.stories.js';

import FooterContact from 'ewi-ui/components/3-organisms/FooterContact/FooterContact.vue';
import { Default as FooterContactArgs } from 'ewi-ui/components/3-organisms/FooterContact/FooterContact.stories.ts';

import FooterNavigation from 'ewi-ui/components/3-organisms/FooterNavigation/FooterNavigation.vue';
import { Default as FooterNavigationArgs } from 'ewi-ui/components/3-organisms/FooterNavigation/FooterNavigation.stories.ts';

import Accordion from 'ewi-ui/components/3-organisms/Accordion/Accordion.vue';
import FabButton from 'ewi-ui/components/1-atoms/FabButton/FabButton.vue';
import { DarkFab as FabButtonArgs } from 'ewi-ui/components/1-atoms/FabButton/FabButton.stories.ts';

import FaqThemeCardList from 'ewi-ui/components/3-organisms/FaqThemeCardList';
import { Default as FaqThemeCardListArgs } from 'ewi-ui/components/3-organisms/FaqThemeCardList/FaqThemeCardList.stories.ts';

export default {
  name: 'HomePage',
  components: {
    PromoLine,
    HeaderNavigation,
    StageHero,
    Information,
    CardSlider,
    FooterContact,
    TextBlock,
    MediaBlock,
    MediaBlockWithWrapText,
    AppBanner,
    Calculator,
    IconText,
    FooterNavigation,
    Accordion,
    FabButton,
    FaqThemeCardList,
  },
  props: {},
  data() {
    return {
      promoLineArgs: {},
      stageHeroArgs: {},
      calculatorArgs: {},
      iconTextArgs: {},
      informationArgs: {},
      cardSliderArgs: {},
      footerContactArgs: {},
      textBlockArgs: {},
      mediaBlockArgs: {},
      mediaBlockVideoArgs: {},
      mediaBlockWithWrapTextArgs: {},
      appBannerArgs: {},
      accordionArgs: {},
      fabButtonArgs: {},
      footerNavigationArgs: {},
      faqThemeCardListArgs: {},
    };
  },
  setup(props) {
    props = reactive(props);
    return {};
  },
  created() {
    this.promoLineArgs = PromoLineArgs.args;
    this.stageHeroArgs = StageHeroArgs.args;
    this.calculatorArgs = CalculatorArgs.args;
    this.iconTextArgs = IconTextArgs.args;
    this.informationArgs = InformationArgs.args;
    this.cardSliderArgs = CardSliderArgs.args;
    this.footerContactArgs = FooterContactArgs.args;
    this.textBlockArgs = TextBlockArgs.args;
    this.mediaBlockArgs = MediaBlockArgs.args;
    this.mediaBlockVideoArgs = WithVideoYoutubeArgs.args;
    this.mediaBlockVideoNativeArgs = WithVideoNativeArgs.args;
    this.mediaBlockWithWrapTextArgs = MediaBlockWithWrapTextArgs.args;
    this.appBannerArgs = AppBannerArgs.args;
    this.footerNavigationArgs = FooterNavigationArgs.args;
    this.faqThemeCardListArgs = FaqThemeCardListArgs.args;
    this.accordionArgs = {
      title: 'Accordion Title',
      items: [
        {
          isOpen: false,
          title: ' Accordion Item',
          border: true,
          content:
            '\n       <h3>Das ist eine Headline</h3>\n      <p>Ab dem 01.01.2021 wird ein einheitlicher Preis für den Ausstoß von CO2 erhoben mit dem Ziel, die aus Emissionen resultierenden Auswirkungen wie z.B. die globale Erwärmung zu verringern und die deutschen Klimaziele zu erreichen. Betroffen hiervon sind Benzin, Gas, Diesel und Heizöl. Die CO2-Belastung wurde von der Bundesregierung einheitlich festgelegt, Grundlage ist das Brennstoffemissionshandelsgesetz (BEHG). Die Einnahmen aus der CO2-Belastung sollen für eine Entlastung von Pendlern genutzt werden</p>\n     \n      ',
          links: [
            {
              default: 'LinkButton',
              url: '#',
              ariaLabel: 'LinkButton',
              type: 'primary',
            },
            {
              default: 'LinkButton',
              url: '#',
              ariaLabel: 'LinkButton',
              type: 'outlined',
            },
          ],
        },
        {
          isOpen: false,
          title: 'Accordion Item',
          border: true,
          content:
            '\n      <img src="/layout/storybook/sb-assets/friends.png" alt="Example image"/>\n      <h3>Das ist eine Headline</h3>\n      <p>Ab dem 01.01.2021 wird ein einheitlicher Preis für den Ausstoß von CO2 erhoben mit dem Ziel, die aus Emissionen resultierenden Auswirkungen wie z.B. die globale Erwärmung zu verringern und die deutschen Klimaziele zu erreichen. Betroffen hiervon sind Benzin, Gas, Diesel und Heizöl. Die CO2-Belastung wurde von der Bundesregierung einheitlich festgelegt, Grundlage ist das Brennstoffemissionshandelsgesetz (BEHG). Die Einnahmen aus der CO2-Belastung sollen für eine Entlastung von Pendlern genutzt werden</p>\n     \n      ',
          links: [
            {
              default: 'LinkButton',
              url: '#',
              ariaLabel: 'LinkButton',
              type: 'primary',
            },
            {
              default: 'LinkButton',
              url: '#',
              ariaLabel: 'LinkButton',
              type: 'outlined',
            },
          ],
        },
        {
          isOpen: true,
          title: 'Open Accordion Item',
          border: true,
          content:
            '\n      <img src="/layout/storybook/sb-assets/friends.png" alt="Example image"/>\n      <h3>Das ist eine Headline</h3>\n      <p>Ab dem 01.01.2021 wird ein einheitlicher Preis für den Ausstoß von CO2 erhoben mit dem Ziel, die aus Emissionen resultierenden Auswirkungen wie z.B. die globale Erwärmung zu verringern und die deutschen Klimaziele zu erreichen. Betroffen hiervon sind Benzin, Gas, Diesel und Heizöl. Die CO2-Belastung wurde von der Bundesregierung einheitlich festgelegt, Grundlage ist das Brennstoffemissionshandelsgesetz (BEHG). Die Einnahmen aus der CO2-Belastung sollen für eine Entlastung von Pendlern genutzt werden</p>\n     \n      ',
          links: [
            {
              default: 'LinkButton',
              url: '#',
              ariaLabel: 'LinkButton',
              type: 'primary',
            },
            {
              default: 'LinkButton',
              url: '#',
              ariaLabel: 'LinkButton',
              type: 'outlined',
            },
          ],
        },
      ],
      theme: 'blue',
    };
    this.headerNavigationArgs = {
      variant: 'Full',
      skipToContentText: 'Zum Inhalt springen',
      primaryNavigation: {
        variant: 'Full',
        navItems: [
          {
            title: 'Strom',
            href: 'strom',
            text: 'Strom',
            subnav: {
              title: 'Strom',
              links: [
                { title: 'Strom', href: 'strom', text: 'Strom' },
                {
                  title: 'Stromtarife von E WIE EINFACH',
                  href: 'strom/stromtarife',
                  text: 'Stromtarife',
                },
                {
                  title: 'Gewerbestrom » Vergleiche Gewerbestromtarife',
                  href: 'geschaeftskunden/gewerbestrom',
                  text: 'Gewerbestrom',
                },
                {
                  title: 'Strom-Ratgeber',
                  href: 'strom/ratgeber',
                  text: 'Strom-Ratgeber',
                },
              ],
            },
          },
          {
            title: 'Gas',
            href: 'gas',
            text: 'Gas',
            subnav: {
              title: 'Gas',
              links: [
                { title: 'Gas', href: 'gas', text: 'Gas' },
                {
                  title: 'Gastarife',
                  href: 'gas/gastarife',
                  text: 'Gastarife',
                },
                {
                  title: 'MeinSmartTarif',
                  href: 'gas/meinsmarttarif-gas',
                  text: 'MeinSmartTarif',
                },
                {
                  title: 'Gewerbegas',
                  href: 'geschaeftskunden/gewerbegas',
                  text: 'Gewerbegas',
                },
              ],
            },
          },
          {
            title: 'Nachhaltigkeit',
            href: 'nachhaltigkeit',
            text: 'Nachhaltigkeit',
          },
          {
            title: 'Service',
            href: 'service',
            text: 'Service',
            subnav: {
              title: 'Service',
              links: [
                { title: 'Service', href: 'service', text: 'Service' },
                {
                  title: 'Marktlage',
                  href: 'aktuelle-lage-energiemarkt/ubersicht-der-aktuellen-lage',
                  text: 'Marktlage',
                },
                {
                  title: 'Kontakt',
                  href: 'service/kontakt',
                  text: 'Kontakt',
                },
                {
                  title: 'Chat',
                  href: 'service/chat',
                  text: 'Chat',
                },
                {
                  title: 'FAQ',
                  href: 'faq',
                  text: 'FAQ',
                },
                {
                  title: 'E WIE EINFACH App',
                  href: 'service/app',
                  text: 'E WIE EINFACH App',
                },
                {
                  title: 'Umzug',
                  href: 'service/umzug',
                  text: 'Umziehen',
                },
                {
                  title: 'E WIE EINFACH kündigen - Online-Kündigungsformular',
                  href: 'service/kuendigung',
                  text: 'Kündigen',
                },
                {
                  title: 'Freund:innen werben',
                  href: 'https://www.ewieeinfach-freundewerben.de/?pk_campaign=EWI-Website-Navigation-Service',
                  text: 'Freund:innen werben',
                },
                {
                  title: 'Vertriebspartner:in werden & schnell Geld verdienen',
                  href: 'service/vertriebspartner-werden',
                  text: 'Vertriebspartner:in werden',
                },
              ],
            },
          },
          {
            title: 'Über uns',
            href: 'ueber-uns',
            text: 'Über uns',
            subnav: {
              title: 'Über uns',
              links: [
                { title: 'Über uns', href: 'ueber-uns', text: 'Über uns' },
                {
                  title: 'Auszeichnungen',
                  href: 'ueber-uns/auszeichnungen',
                  text: 'Auszeichnungen',
                  ariaLabel: 'Auszeichnungen',
                },
                {
                  title: 'Jobs',
                  href: 'ueber-uns/jobs-und-karriere',
                  text: 'Jobs',
                  ariaLabel: 'Jobs',
                },
                {
                  title: 'Presse und Downloads',
                  href: 'ueber-uns/newsroom',
                  text: 'Presse und Downloads',
                  ariaLabel: 'Presse und Downloads',
                },
                {
                  title: 'Kontakt',
                  href: 'ueber-uns/kontakt',
                  text: 'Kontakt',
                },
                {
                  title: 'Datenschutz',
                  href: 'ueber-uns/datenschutz',
                  text: 'Datenschutz',
                  ariaLabel: 'Datenschutz',
                },
                {
                  title: 'Impressum',
                  href: 'ueber-uns/impressum',
                  text: 'Impressum',
                  ariaLabel: 'Impressum',
                },
              ],
            },
          },
        ],
      },
    };
    this.fabButtonArgs = FabButtonArgs.args;
  },
};
</script>
